import { render } from "./OrdersToDispatch.vue?vue&type=template&id=0fa03ae7"
import script from "./OrdersToDispatch.vue?vue&type=script&lang=js"
export * from "./OrdersToDispatch.vue?vue&type=script&lang=js"

import "./OrdersToDispatch.vue?vue&type=style&index=0&id=0fa03ae7&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__